import * as types from '../actions/types'

const initialState = {
    loading : false,
    vehicles : [],
    error : null
}


const vehicleReducer = (state = initialState , action) => {
    switch(action.type){
        case types.FETCH_VEHICLES_REQUEST:{
            return {
                ...state,
                loading: true
            }
        }
        case types.FETCH_VEHICLES_SUCCESS:{
            return {
                ...state,
                loading: false,
                vehicles : action.payload
            }
        }
        case types.FETCH_VEHICLES_FAILED:{
            return {
                ...state,
                loading : false,
                error: action.payload
            }
        }
        default:{
            return {
                ...state
            }
        }
    }
}

export default vehicleReducer